// src/app/features/color-systems/models/color-systems.models.ts

export type ColorType =
  | 'Main colors'
  | 'Brand'
  | 'Error'
  | 'Neutral'
  | 'Success'
  | 'Warning';

export interface ColorSystem {
  color_id: number;
  color_type: ColorType; // ej: "Brand"
  color_code: string; // ej: "#2499cb"
  color_name_value: string; // ej: "--brand-500"
  color_is_used: boolean; // ej: true
  color_title_client: string; // ej: "brand 500"

  color_is_deleted: boolean | null;
  color_created_by: number | string | null;
  color_created_date: string | null;
  color_update_by: number | string | null;
  color_update_date: string | null;
}

export interface ColorSystemsResponse {
  data: ColorSystem[];
  message: string;
  code: number;
}

export interface ColorSystemByIdResponse {
  data: ColorSystem;
  message: string;
  code: number;
}

export enum colorEndpoint {
  getColors = 'color-systems',
  updateColorById = 'color-systems/update',
}
